<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">用户列表</div>
      <div class="page-header-btn">
        <el-button v-if="loginUserRole<=1" icon="el-icon-plus" size="mini" style="margin-right: 1rem;" type="primary" @click="add">添加</el-button>
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="getUserListLoading"
                   @click="getUserList()"></el-button>
      </div>
    </div>
    <!--设备列表-->
    <el-table :data="userList" border style="width: 100%;font-size: 12px;" :height="winHeight">
      <el-table-column type="index" label="序号" width="50" align="center" />
      <el-table-column prop="username" label="用户名" align="center"/>
      <el-table-column prop="companyName" label="公司名称" align="center">
        <template slot-scope="{row}">
          <span>{{row.company?row.company.companyName:''}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="职务名称"  align="center">
        <template slot-scope="{row}">
          <span>{{row.role?row.role.roleName:''}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"/>
      <el-table-column prop="updateTime" label="更新时间" align="center"/>

      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <el-button-group>
            <el-button size="mini" icon="el-icon-video-camera-solid" v-bind:disabled="row.online==0"
                       type="primary" @click="edit(row)">修改
            </el-button>
            <el-button size="mini" icon="el-icon-delete" type="danger" v-if="row.role.id != 1" @click="del(row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-size="count"
      :page-sizes="[15, 25, 35, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <userEdit ref="userEdit" ></userEdit>
  </div>
</template>

<script>
import userEdit from "./dialog/userEdit";

export default {
  name: "User",
  components: {
    userEdit
  },
  data() {
    return {
      userList: [], //设备列表
      winHeight: window.innerHeight - 200,
      currentPage: 1,
      count: 15,
      total: 0,
      getUserListLoading: false,
      loginUserRole:'',
    }
  },
  created() {
    this.getUserList()
    this.loginUserRole = JSON.parse(sessionStorage.getItem('userRole')).id
  },
  methods:{
    getUserList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/user/all`,params: {
          page: this.currentPage,
          count: this.count
        }}).then(function (res) {
        that.userList = res.data.data;
        that.total = res.data.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getDeviceList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getDeviceList();
    },
    add(){
      this.$refs.userEdit.openDialog(null, this.getUserList)
    },
    edit(row) {
      this.$refs.userEdit.openDialog(row, this.getUserList)
    },
    del(row) {
      let that = this;
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getUserListLoading = true;
        this.$axios({ method: 'delete', url:`/api/user/delete`, params: {id: row.id} }).then( res => {
          if (res.data.code === 0){
            that.$message.success("删除成功！")
            this.getUserList()
          }else {
            that.$message.error(res.data.msg)
          }
          this.getUserListLoading = false;
        })
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/User.vue